import {ModeltypeBasicDto, TechnicalDataDto} from "../../services/Client";
import {GetTechnicalDataDerivatesParams, GetTechnicalDataParams} from "../../services/HATEOASClient";
import {Dispatch} from "react-redux";
import {ActionTypes} from "./ActionTypes";
import {renderErrorToast} from "../../utils/FeedbackMessageUtils";
import GeneralActions from "./GeneralActions";
import {Helpers} from "../reducers/Helpers";
import {IReduxState} from "../IReduxState";

const TechnicalDataViewActions = {
    GetTechnicalData(t: reactI18Next.TranslationFunction, params: GetTechnicalDataParams) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            Helpers.getSomething<TechnicalDataDto[]>(
                dispatch,
                getState(),
                "GET_technicalData",
                "loadingTechnicalData",
                (val) => this.ReceivedTechnicalData(val),
                t("LOAD_TECHDATA"),
                "Requesting technical data failed",
                undefined,
                params);
        };
    },
    UnloadTechnicalData() {
        return {type: ActionTypes.UNLOAD_TECHNICAL_DATA};
    },
    ReceivedTechnicalData(data?: TechnicalDataDto[]) {
        return {type: ActionTypes.RECEIVE_TECHNICAL_DATA, data: data};
    },
    GetTechnicalDataDerivates(t: reactI18Next.TranslationFunction, params: GetTechnicalDataDerivatesParams) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client, baseLinks} = getState().general;

            if (!baseLinks || !client.GET_technicalDataDerivates(baseLinks).canExecute()) {
                renderErrorToast({
                    message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:GET_TECH_DATA_DERIVATES",
                    timestamp: Date.now()
                });
            } else {
                const loadingScreenMessage = t('TECH_DATA_VIEW:GET_TECH_DATA_DERIVATES');
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));
                client.GET_technicalDataDerivates(baseLinks).execute(params)
                    .then((result: ModeltypeBasicDto[]) => {
                        dispatch(this.ReceivedTechnicalDataDerivates(result));
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                    }).catch((reason) => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        renderErrorToast({
                            message: "ERRORS:GET_TECH_DATA_DERIVATES",
                            details: reason,
                            timestamp: Date.now()
                        }
                        );
                    });
            }
        };
    },
    UnloadTechnicalDataDerivates() {
        return {type: ActionTypes.UNLOAD_TECHNICAL_DATA_DERIVATES};
    },
    ReceivedTechnicalDataDerivates(data: ModeltypeBasicDto[]) {
        return {type: ActionTypes.RECEIVE_TECHNICAL_DATA_DERIVATES, data: data};
    }
};

export default TechnicalDataViewActions;



// WEBPACK FOOTER //
// ./src/redux/actions/TechnicalDataViewActions.tsx